<template>
<div id="app">
    <div class="text-center font-interface" id="header"  v-if="!$route.fullPath.includes('view')">
    	<div>
		  <b-navbar toggleable="lg" type="dark" variant="primary" class="py-2">
		    <b-navbar-brand href="#" class="text-uppercase font-weight-bolder">Quote Manager</b-navbar-brand>
		
		    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
		
		    <b-collapse id="nav-collapse" is-nav>
		      <b-navbar-nav>
		        <b-nav-item to="/quotes">Quotes</b-nav-item>
		        <b-nav-item to="/quote">Create Quote</b-nav-item>
		      </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-button size="" class="my-2 my-sm-0 bg-white text-dark px-5 font-weight-bold" v-if="!this.$root.userLoggedIn()" to="/login">Login</b-button>
            <b-button size="" class="my-2 my-sm-0 bg-white text-dark px-5 font-weight-bold" v-if="this.$root.userLoggedIn()" to="/logout">Logout</b-button>
          </b-navbar-nav>
		    </b-collapse>
		  </b-navbar>
		</div>
    </div>
 
    <router-view :key="$route.fullPath"></router-view>
</div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {
            variant: 'dark',
        };
    },
    
};

</script>

<style>
/* eslint-disable */
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 0px !important;
    text-align:left !important;
}
</style>
